import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core'
import { DateFormat, DestroySubscribers } from '@ftr/foundation'
import { LocalTime } from '@js-joda/core'
import { SttRemarkWithPlayerInformation } from '../../SttRemarkWithMetadata'

interface ViewModel {
  speaker: number
  content: string
}

// The height + padding + margin of a placeholder line
export const PLACEHOLDER_LINE_HEIGHT_PX = 35

@Component({
  selector: 'ftr-stt-segment-marker',
  templateUrl: './stt-segment-marker.component.html',
  styleUrls: ['./stt-segment-marker.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SttSegmentMarkerComponent extends DestroySubscribers implements OnInit {
  @Input() remarks: SttRemarkWithPlayerInformation[]

  /**
   * Set a precise height of a segment's rendered remarks so even when
   * PLACEHOLDER_LINE_HEIGHT_PX isn't perfectly divisible by that height
   * there won't be a height difference between this component and the remarks
   */
  @Input()
  @HostBinding('style.height')
  height: string

  // Display a randomized transcript skeleton below a time marker when remark content is being loaded
  loadingRemarkPlaceholderWidths: ViewModel[]

  readonly dateFormats = DateFormat

  ngOnInit(): void {
    // Plus 1 to account for the first time marker
    this.height = this.height || `${PLACEHOLDER_LINE_HEIGHT_PX * (this.remarks.length + 1)}px`
    // Minus 1 so that the last line won't exceed @Input() height
    const loadingRemarkPlaceholderLines = Math.floor(parseInt(this.height, 10) / PLACEHOLDER_LINE_HEIGHT_PX) - 1
    this.loadingRemarkPlaceholderWidths = getPlaceholderModel(Math.max(1, loadingRemarkPlaceholderLines))
  }
}

function getPlaceholderModel(lines: number): ViewModel[] {
  return Array.from(Array(lines)).map(() => ({
    speaker: Math.floor(Math.random() * 2),
    content: `${Math.floor(Math.random() * LocalTime.SECONDS_PER_MINUTE) + 10}%`,
  }))
}
